const printing_services_swiper = new Swiper('.custom-collections__wrapper', {
    speed: 3000,
    spaceBetween: 20,
    grabCursor: true,
    slidesPerView: 1.055,
    slidesPerGroup: 1,
    pagination: {
        el: '.swiper__dots',
        clickable: true,
        type: 'bullets',
        renderBullet: function (index, className) {
            return `<span class="${className} custom-bullet">  
                  </span>`;
        }    
    },
    breakpoints: {
        1300: {
            slidesPerView: 3.2,
            slidesPerGroup: 2
        },
        600: {
            slidesPerView: 2.2,
            slidesPerGroup: 2
        }
    }
});

document.querySelector(".swiper__next").addEventListener("click", () => {
    printing_services_swiper.slideNext();
})
document.querySelector(".swiper__prev").addEventListener("click", () => {
    printing_services_swiper.slidePrev();
})